import axios from "axios"

export const BankApi = {
    async List(){
        const response = await axios.get(`/api/bank/list`)
        return response
    },
    async BankParameterList(data){
        const response = await axios.get(`/api/bank/bankparameter/list/${data}`)
        return response
    },
    async BankParameterUpdate(data){
        const response = await axios.post(`/api/bank/bankparameter/update`,data)
        return response
    },
}